import React, { Component } from 'react';
import {DataTable} from 'primereact/components/datatable/DataTable';
import {Column} from 'primereact/components/column/Column';
import {Accordion} from 'primereact/components/accordion/Accordion';
import {AccordionTab} from 'primereact/components/accordion/Accordion';
//import { SPECIAL_NOTE_ACTIVATE,SPECIAL_NOTE } from '../constants';

export class AiReview extends Component {
    
    render() {
     //   console.log('REVIEW render')
        var w = window.innerWidth
        var h = window.innerHeight
        if (w > 640) {
            w=640
        }
        if (h > 640) {
            h=640
        }
       // var note1 =<div>Actual presentation might appear slightly different from preview. Aquamarine stones come in a variety of shades and in some instances appear clear in color. Your stone may not be as vibrant as the image depicted above. Our experts will ensure the proper size and placement of your message. Inappropriate and profane language may result in the cancellation of your order.</div>
          //const note2a = <div><font color='red'>Due to COVID-19, shipping is taking longer than expected. We will do our best to make sure your package arrives in time for Mother’s Day. This delivery date overrides regular processing times noted below.</font></div>
       // var note2a = <div><font color='red'>Order by Friday, April 23, 2021 for Mother's Day delivery. This delivery date overrides regular processing times. </font></div>
        var note2a = <div><font color='red'></font></div>
        var note2 = <div></div>
        
        //const note2a = <div><font color='red'>Due to COVID-19, shipping is taking longer than expected. We will do our best to make sure your package arrives in time for Mother’s Day. This delivery date overrides regular processing times noted below.</font></div>
        if (this.props.gems)
            note2a = <div><b><u>Gemstones</u></b><p/>Most natural gemstones pictured have been subject to an enhancement process or treatment (e.g. heating, oiling, diffusion, waxing, etc.), which may not be permanent and may require special care. Please refer to the Quick Links section at the bottom of the page for the 'Jewellery Care' section for special jewellery care recommendations</div>
        //console.log('REVIEW STATE2',window.currentSite)
      
            
       
        let headercolor ='ai-review-header ai-review-' + window.currentSite
        var note1b = <div className="ui-accordion" style={{padding:"20px"}}>
        <b><u>Shipping</u></b><p/> Your personalised jewellery will reach you within 10 business days<p/> 
        <b><u>Returns and Replacements</u></b><p/>Upon receiving your order, please inspect the product immediately for any issues such as damage, incorrect quantity, or discrepancies with your order specifications (e.g., spelling errors, wrong gemstone, incorrect metal color). Report any issues to us WITHIN 24 HOURS of delivery by sending clear photos by email to support@guyal.com. If approved, a free replacement and reverse pick-up will be arranged<p/>
        <b><u>Cancellations</u></b><p/>You can make any changes or cancellations within 2 hours of placing the order. No changes/cancellations are permitted after 2 hours, because we start work on your orders immediately upon receipt<p/>
        <b><u>Payment</u></b><p/>We accept only prepaid orders.
        </div>
        
       // if (this.props.bolo)
       //     note1b = ' cannot be resized'
       //if (this.props.gems)
        // noteGem = <div>Most natural gemstones pictured have been subject to an enhancement process or treatment (e.g. heating, oiling, diffusion, waxing, etc.), which may not be permanent and may require special care. Please refer to the FAQ section below for more information about gemstone enhancements and special care recommendations.</div>
        return (<div>
            <div className={"ai-review " + this.props.showReview} >
                <Accordion  onTabOpen={this.props.onOpenReview} >
                <AccordionTab header="Review"   headerClassName={headercolor}  icon="pi pi-plus" >
                        <div className='ai-review-title'> {this.props.description}</div> 
                        <DataTable value={this.props.properties}>
                        <Column field="property" header="Property"  style={{width:'35%'}}/>
                        <Column field="value" header="Value" />
                       
                        </DataTable>
                        
                        
                        <div className='ai-review-note'>
                        {note2a}
                        </div>      
                        <div className='ai-review-note'>
                        {note2}
                        </div>       
                       
                        <div className='ai-version'>Version {this.props.version}</div>
                        <p/>
                    </AccordionTab> 
                    
                </Accordion>
       
                
            </div>
            <div className='ai-review-note'>
                        {note1b}
                        </div>       
        
            </div>
        )
    }
}
export default AiReview;



// WEBPACK FOOTER //
// ./src/layout/AiReview.js